export const createDraggableId = (goalId, parentIds) => `goal_${goalId}_parents_${parentIds.join(',')}`;

export const parseDraggableGoalId = (id) => parseInt(id.split('goal_')[1], 10);
export const parseDraggableParentIds = (id) => {
  const s = id.split('parents_');
  if (s.length < 2) {
    return [];
  }
  return s[1].split(',').map((id) => parseInt(id, 10));
};
